// src/pages/Error404.js
import React, { useContext } from "react";
import { Box, Heading, Button, Text } from "grommet";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const Error404 = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const handleRedirect = () => {
    if (!user) {
      navigate("/");
      return;
    }
    if (user.role === "manager") {
      navigate(`/add-proficiency/${user.user_table_id}`);
    } else {
      navigate(`/add-proficiency/${user.user_id}`);
    }
  };
  return (
    <Box align="center" justify="center" pad="large" height="100vh">
      <Heading level="1">404</Heading>
      <Text size="large">
        Oops! This page does not exist or you do not have enough permissions to
        access the page.
      </Text>
      <Button
        label="Go Back to Home"
        onClick={handleRedirect}
        margin={{ top: "medium" }}
        primary
      />
    </Box>
  );
};

export default Error404;
